module.exports = __webpack_public_path__ + "static/logistics-icn-9657c22e9c02aed18a5150b76423aab2.svg";